import { TransactionData } from './../data/TransactionData';
import { Transaction } from 'src/app/data/Transaction';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from './auth.service';
import { HeaderService } from './header.service';
import { environment } from '../../environments/environment';
import { CardholderDetails } from '../data/CardholderDetails';
import {Merchant} from "../Merchant";

@Injectable({
  providedIn: 'root'
})
export class CardholderUserService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private headerService: HeaderService
  ) {}

  getCardholderDetails(merchant?: string): Observable<CardholderDetails> {
    const url = `${environment.rootApiUrl}/cardholderview/cardholderDetails`;
    const params = new HttpParams()
       .append('merchantCard', merchant);
    return this.http.get<CardholderDetails>(url, {
      headers: this.headerService.getXAuthHeaderFromCookie(),
      params: params
    });
  }

  getTransactionData(
    acctNum: string,
    startDate: string,
    endDate: string,
    merchant?: string
  ): Observable<TransactionData> {
    const url = `${environment.rootApiUrl}/cardholderview/transactiondata`;
    let params = new HttpParams();
    params = params.append('acctNum', acctNum || '');
    params = params.append('startDate', startDate || '');
    params = params.append('endDate', endDate || '');
    params = params.append('merchantCard', merchant);

    return this.http.post<TransactionData>(url, params, this.headerService.getHttpOptionsXAuthHeaderFromCookie());
  }

  getC2CDetails(
    payrollAccount: number,
    tranSeq: number,
    tranType: string
  ): Observable<Transaction> {
    const url = `${environment.rootApiUrl}/common/cardholders/c2cDetails/`;
    let params = new HttpParams();
    params = params.append('acctNum', payrollAccount.toString() || '');
    params = params.append('tranSeq', tranSeq.toString() || '');
    params = params.append('tranType', tranType || '');

    return this.http.get<Transaction>(url, {
      headers: this.headerService.getXAuthHeaderFromCookie(),
      params: params
    });
  }
}
